export default {
	AUTH_STARTED: 'AuthStarted',
	AUTH_COMPLETED: 'AuthCompleted',
	PASSWORD_RESET_STARTED: 'PasswordResetStarted',
	PASSWORD_RESET_COMPLETED: 'PasswordResetCompleted',
	OPTIN_STARTED: 'OptInStarted',
	CLICKED_WHEN_PENDING: 'ClickedWhenPending',
};
